import {Component, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-exg-select-v2',
  templateUrl: './exg-select-v2.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR, useExisting: ExgSelectV2Component, multi: true
  }]
})
export class ExgSelectV2Component implements OnInit, ControlValueAccessor {

  @Input() caption!: string;
  @Input() list: Array<any> = [];
  @Input() listDisplay!: string;
  @Input() disabled = false;
  @Input() required = false;
  @Input() dateDisplay = false;
  @Input() dateFormat = 'Globals.DateFormat';

  index = 0;

  private keyBuffer = '';
  private keyBufferTimer: any = null;

  _value: any = null;
  get value(): any {
    return this._value;
  }

  set value(obj: any) {

    this._value = obj;
    if (!this.list[obj]) {
      this._value = null;
    }
    this.onChange(this._value);
    this.onTouched(this._value);
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor() {
  }

  // ControlValueAccessor -> OUT
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // ControlValueAccessor <- IN
  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {

    this._value = obj;
  }

  // ---------------

  ngOnInit(): void {
  }

  public displayItem(item: any): any {
    if (this.listDisplay) {
      if (item) {
        return item[this.listDisplay];
      } else {
        return '-';
      }
    } else {
      if (item) {
        return item;
      } else {
        return '-';
      }
    }
  }

  change(newValue: any): void {
    this.value = newValue;
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key.length !== 1) { return; } // Pfeiltasten etc. ignorieren

    // Buffer aufbauen für mehrere Buchstaben (z.B. "Sc" → "Schulz")
    this.keyBuffer += event.key.toLowerCase();

    clearTimeout(this.keyBufferTimer);
    this.keyBufferTimer = setTimeout(() => this.keyBuffer = '', 500);

    const index = this.list.findIndex(item =>
      this.displayItem(item)?.toString().toLowerCase().startsWith(this.keyBuffer)
    );

    if (index !== -1) {
      event.preventDefault();
      this.value = index;
    }
  }
}
